// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__1WfX8","buttons":"styles_buttons__BQskM"};